import { AlertTriangle, ArrowLeft, Loader2, Frown } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

export type DealGuardStatus = "loading" | "missingId" | "notFound";

export default function DealGuard({ status }: { status: DealGuardStatus }) {
  const navigate = useNavigate();

  const messages = {
    loading: {
      title: "Loading Deal...",
      body: "Please wait while we fetch the project data.",
      icon: Loader2,
      animate: "animate-spin",
    },
    missingId: {
      title: "No Deal Selected",
      body: "Please go back to the dashboard and open a deal.",
      icon: AlertTriangle,
      animate: "",
    },
    notFound: {
      title: "Deal Not Found",
      body: "We couldn't find this deal. It may have been removed.",
      icon: Frown,
      animate: "",
    },
  };

  const config = messages[status] || messages.notFound;
  const Icon = config.icon;

  return (
    <div className="w-full max-w-[95vw] mx-auto rounded-xl border border-slate-200 bg-white p-6">
      <div className="flex flex-col items-center justify-center text-center space-y-4 py-8">
        <div
          className={`flex items-center justify-center h-12 w-12 rounded-full ${
            status === "loading"
              ? "bg-blue-100 text-blue-600"
              : "bg-amber-100 text-amber-600"
          }`}
        >
          <Icon className={`h-6 w-6 ${config.animate}`} />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">
            {config.title}
          </h2>
          <p className="text-sm text-slate-600">{config.body}</p>
        </div>
        {status !== "loading" && (
          <Button
            onClick={() => navigate("/underwriting")}
            className="flex items-center space-x-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Back to Deals</span>
          </Button>
        )}
      </div>
    </div>
  );
}
